import {FormGroup} from "@angular/forms";

export function PasswordMatchValidator(password: string, confirmPassword: string, formSubmitted: boolean, errorElementName: string) {
    return (formGroup: FormGroup) => {
        if (errorElementName && formGroup.controls[errorElementName]) {
            const errorElement = formGroup.controls[errorElementName];
            errorElement.setErrors(null);

            if (formSubmitted) {
                if ((password === null || password === undefined || password.length === 0)
                        || (confirmPassword === null || confirmPassword === undefined || confirmPassword.length === 0)) {
                    errorElement.setErrors({ invalid: true });
                } else {
                    if (password === confirmPassword) {
                        /* combination is good */
                    } else {
                        errorElement.setErrors({ invalid: true });
                    }
                }
            }
        }
        return null;
    };
}
